import { CustomModal, ProtectedImg, ProtectedLink } from "components";
import { leaveTypes, periodMap } from "./constants";
import { absTimeDifference } from "utils/timeDifference";
import { getFileExtension } from "utils/getFileExtension";
import { capitalize } from "utils/capitalize";
import moment from "moment";

export const eventTypes = {
    ATTENDANCE: "Attendance",
    STAFF_APPLICATION: "Staff Application",
};

const StaffAttendanceOrLeaveModal = ({ state, dispatch }) => {
    const hideModal = () => dispatch({ type: "close" });
    return (
        <CustomModal
            title={`${capitalize(state?.data?.eventType)}`}
            show={state?.open}
            hideModal={hideModal}
            compact={true}
        >
            <div className="row text-white px-4 text-left">
                <div className="col-12 col-sm-6 mb-4">
                    <div className="font-weight-bold text-primary">
                        {capitalize(state?.data?.type)} Date
                    </div>
                    <div>
                        {new Date(state?.data?.date).toString().slice(0, 15)}
                    </div>
                </div>
                {state?.data?.eventType === eventTypes.ATTENDANCE && (
                    <>
                        <div className="col-12 col-sm-6 mb-4">
                            <div className="font-weight-bold text-primary">
                                Arrival Time
                            </div>
                            <div>
                                {moment(state?.data?.start).format(
                                    "hh:mm:ss A"
                                ) +
                                    " (" +
                                    state?.data?.arrivalType +
                                    ")"}
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 mb-4">
                            <div className="font-weight-bold text-primary">
                                Leaving Time
                            </div>
                            <div>
                                {moment(state?.data?.end).format("hh:mm:ss A") +
                                    " (" +
                                    state?.data?.leavingType +
                                    ")"}
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 mb-4">
                            <div className="font-weight-bold text-primary">
                                Remarks
                            </div>
                            <div>{state?.data?.remark}</div>
                        </div>
                    </>
                )}
                {state?.data?.type && (
                    <div className="col-12 col-sm-6 mb-4">
                        <div className="font-weight-bold text-primary">
                            Type
                        </div>
                        <div>
                            {
                                leaveTypes.find(
                                    (leave) => leave.value === state?.data?.type
                                )?.label
                            }
                        </div>
                    </div>
                )}
                {state?.data?.period && (
                    <div className="col-12 col-sm-6 mb-4">
                        <div className="font-weight-bold text-primary">
                            Period
                        </div>
                        <div>{periodMap[state?.data?.period]}</div>
                    </div>
                )}
                {state?.data?.approvedReason && (
                    <div className="col-12 col-sm-6 mb-4">
                        <div className="font-weight-bold text-primary">
                            Approval/Disapproval Reason
                        </div>
                        <div className="text-info">
                            {state?.data?.approvedReason}
                        </div>
                    </div>
                )}
                {state?.data?.startTime && (
                    <div className="col-12 col-sm-6 mb-4">
                        <div className="font-weight-bold text-primary">
                            Start
                        </div>
                        <div>{state?.data?.startTime}</div>
                    </div>
                )}
                {state?.data?.endTime && (
                    <div className="col-12 col-sm-6 mb-4">
                        <div className="font-weight-bold text-primary">End</div>
                        <div>{state?.data?.endTime}</div>
                    </div>
                )}
                {state?.data?.startTime && state?.data?.endTime && (
                    <div className="col-12 col-sm-6 mb-4">
                        <div className="font-weight-bold text-primary">
                            Duration
                        </div>
                        <div>
                            {(
                                absTimeDifference(
                                    state?.data?.startTime,
                                    state?.data?.endTime
                                ) / 60
                            ).toFixed(2)}{" "}
                            hours
                        </div>
                    </div>
                )}
                {state?.data?.eventType === eventTypes.STAFF_APPLICATION && (
                    <div className="col-12 col-sm-6 mb-4">
                        <div className="font-weight-bold text-primary">
                            Deleted
                        </div>
                        <div>{state?.data?.deleted ? "Yes" : "No"}</div>
                    </div>
                )}
                {state?.data?.reason && (
                    <div className="col-12 mb-4">
                        <div className="font-weight-bold text-primary">
                            Reason
                        </div>
                        <div>{state?.data?.reason}</div>
                    </div>
                )}

                {state?.data?.proof && (
                    <div className="col-12 text-left">
                        <div className="font-weight-bold text-primary">
                            Proof
                        </div>
                        {getFileExtension(state?.data?.proof) === "pdf" ? (
                            <ProtectedLink
                                href={state?.data?.proof}
                                target="_blank"
                                className="badge badge-secondary"
                                label="Click To View Proof"
                            />
                        ) : (
                            <ProtectedImg
                                src={state?.data?.proof}
                                alt=""
                                className="img-fluid"
                            />
                        )}
                    </div>
                )}
            </div>
        </CustomModal>
    );
};

export default StaffAttendanceOrLeaveModal;
